export class FrozenEmbryoTransfer {
    fetDate: Date
    table: Array<FrozenEmbryoTransfertable>
    consultant: string
    embryologist: string;
    dateOfFreezing: string;
    remaingEmbryos: string;
    dateOfTransfer: string;
    catheterList: string;
    noOfEmbryosFrozen: string;
    timeOfTransfer: string;
    transfer: string;
    scheduledDateofRenewal: string;
    clinician: string;
    stateOfCatherter: string;
    comments: string;
    embryologistSignature: string;
    witnessSignature: string;   
    embroyologistSignaturePath: string;
    witnessSignatureRootPath: string;
    embroyologistSignature: string;
    witnessName: string;
    embryologistName: string;
}
export class FrozenEmbryoTransfertable {
    cryotopNo: string;
    dateOfThawing: string;
    embryosFrozen: string;

    cellStageAtFreezing: string;
    noOfEmbryosSurvived: string;
    postThawCellStage: string;
    overnightCulture: string;
    assistedHatching: string;
    result: string;

    cellStageAtFreezing2: string;
    noOfEmbryosSurvived2: string;
    postThawCellStage2: string;
    overnightCulture2: string;
    assistedHatching2: string;
    result2: string;

    cellStageAtFreezing3: string;
    noOfEmbryosSurvived3: string;
    postThawCellStage3: string;
    overnightCulture3: string;
    assistedHatching3: string;
    result3: string;



}